import { render, staticRenderFns } from "./ImageEdit.vue?vue&type=template&id=b4e096ae&scoped=true"
import script from "./ImageEdit.vue?vue&type=script&lang=js"
export * from "./ImageEdit.vue?vue&type=script&lang=js"
import style0 from "./ImageEdit.vue?vue&type=style&index=0&id=b4e096ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e096ae",
  null
  
)

export default component.exports